export default {"src":"/_next/static/media/icon-confirm-btn-shine.8a5595c3.svg","height":72,"width":81,"blurWidth":0,"blurHeight":0};